<template>
  <ul class="list-inline">
    <li v-if="mediaLinks.facebookUrl" class="list-inline-item">
      <a v-bind:href="mediaLinks.facebookUrl" target="_blank">
        <icon name="facebook-f"></icon>
      </a>
    </li>
    <li v-if="mediaLinks.twitterUrl" class="list-inline-item">
      <a v-bind:href="mediaLinks.twitterUrl" target="_blank">
        <icon name="twitter"></icon>
      </a>
    </li>
    <li v-if="mediaLinks.linkedInUrl" class="list-inline-item">
      <a v-bind:href="mediaLinks.linkedInUrl" target="_blank">
        <icon name="linkedin"></icon>
      </a>
    </li>
    <li v-if="mediaLinks.googlePlusUrl" class="list-inline-item">
      <a v-bind:href="mediaLinks.googlePlusUrl" target="_blank">
        <icon name="google-plus"></icon>
      </a>
    </li>
    <li v-if="mediaLinks.youTubeUrl" class="list-inline-item">
      <a v-bind:href="mediaLinks.youTubeUrl" target="_blank">
        <icon name="youtube"></icon>
      </a>
    </li>
  </ul>
</template>
<script>
  export default {
    name: 'social-media-buttons',
    props: {
      mediaLinks: {
        type: Object,
        default: function () {
          return {
            facebookUrl: '',
            twitterUrl: '',
            linkedInUrl: '',
            googlePlusUrl: '',
            youTubeUrl: ''
          }
        }
      }
    },
    data () {
      return {
      }
    }
  }
</script>
<style lang="scss">
  .list-inline {
      margin-bottom: 0;
      margin-top: 5px;
    .list-inline-item {
      background-color: $secondary-color;
      width: 24px;
      height: 24px;
      text-align: center;
      padding-top: 2px;
      cursor: pointer;

      &:hover {
         background-color: darken($secondary-color, 5%);
       }

      a {
        color: $white !important;
        width: 100%;
        height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// SocialMediaButtonsComponent.vue?56adf1c6